

const CardroomSubscriptionEditor = ({ cardroom }) => {
    return "SUBSCRIPTION"
};


export default CardroomSubscriptionEditor;